import './SinglePage.less';
import React from 'react';
import Layout from "../layout/Layout";
import {BrowserRouter, Switch} from "react-router-dom";
import routes from "../routing/routes";
import ContextsWrapper from "../contexts/ContextsWrapper";
import NotFoundApp from "../apps/not-found/NotFoundApp";
import ForbiddenApp from "../apps/forbidden/ForbiddenApp";
import UnexpectedApp from "../apps/unexpected/UnexpectedApp";
import HomeApp from "../apps/home/HomeApp";
import RegisterApp from "../apps/register/RegisterApp";
import LoginApp from "../apps/login/LoginApp";
import ForgotPasswordApp from "../apps/forgot-password/ForgotPasswordApp";
import ResetPasswordApp from "../apps/reset-password/ResetPasswordApp";
import VerifyEmailApp from "../apps/verify-email/VerifyEmailApp";
import TermsAndConditionsApp from "../apps/terms-and-conditions/TermsAndConditionsApp";
import PrivacyPolicyApp from "../apps/privacy-policy/PrivacyPolicyApp";
import CourseApp from "../apps/course/CourseApp";
import CheckoutApp from "../apps/checkout/CheckoutApp";
import LibraryApp from "../apps/library/LibraryApp";
import LearningApp from "../apps/learning/LearningApp";
import DashboardApp from '../apps/dashboard/DashboardApp';
import UserManagementApp from "../apps/user-management/UserManagementApp";
import ComboManagementApp from '../apps/combo-management/ComboManagementApp';
import CourseManagementApp from "../apps/course-management/CourseManagementApp";
import ImageManagementApp from "../apps/image-management/ImageManagementApp";
import VideoManagementApp from "../apps/video-management/VideoManagementApp";
import ChapterManagementApp from "../apps/chapter-management/ChapterManagementApp";
import LessonManagementApp from "../apps/lesson-management/LessonManagementApp";
import AudioManagementApp from "../apps/audio-management/AudioManagementApp";
import DocumentManagementApp from "../apps/document-management/DocumentManagementApp";
import EnrollmentManagementApp from "../apps/enrollment-management/EnrollmentManagementApp";
import QuizManagementApp from "../apps/quiz-management/QuizManagementApp";
import ProtectedRoute from "../routing/components/ProtectedRoute";
import AuthRoute from "../routing/components/AuthRoute";
import UserProfileApp from "../apps/user-profile/UserProfileApp";
import AccountApp from "../apps/account/AccountApp";
import BannerManagementApp from "../apps/banner-management/BannerManagementApp";
import ArticleManagementApp from '../apps/article-management/ArticleManagementApp';
import PromotionManagementApp from '../apps/promotion-management/PromotionManagementApp';
import RegularRoute from "../routing/components/RegularRoute";
import ArticleApp from '../apps/article/ArticleApp';
import PromotionApp from '../apps/promotion/PromotionApp';


export default function SinglePage({}) {
    
    return <div className="single-page">
        <ContextsWrapper>
            <BrowserRouter>
                <Layout>
                    <Switch>
                        <RegularRoute path={routes.home.path} component={HomeApp} exact/>
                        <RegularRoute path={routes.course.path} component={CourseApp} exact/>
                        <RegularRoute path={routes.article.path} component={ArticleApp} exact/>
                        <RegularRoute path={routes.promotion.path} component={PromotionApp} exact/>
                        <RegularRoute path={routes.terms_and_conditions.path} component={TermsAndConditionsApp} exact/>
                        <RegularRoute path={routes.privacy_policy.path} component={PrivacyPolicyApp} exact/>
                        <RegularRoute path={routes.user_profile.path} component={UserProfileApp} exact/>
                        <AuthRoute path={routes.register.path} component={RegisterApp} exact/>
                        <AuthRoute path={routes.login.path} component={LoginApp} exact/>
                        <AuthRoute path={routes.forgot_password.path} component={ForgotPasswordApp} exact/>
                        <AuthRoute path={routes.reset_password.path} component={ResetPasswordApp} exact/>
                        <AuthRoute path={routes.verify_email.path} component={VerifyEmailApp} exact/>
                        <ProtectedRoute path={routes.library.path} component={LibraryApp} exact/>
                        <ProtectedRoute path={routes.learning.path} component={LearningApp} exact/>
                        <ProtectedRoute path={routes.account.path} component={AccountApp} exact/>
                        <ProtectedRoute path={routes.checkout.path} component={CheckoutApp} exact/>
                        <ProtectedRoute path={routes.dashboard.path} component={DashboardApp} exact/>
                        <ProtectedRoute path={routes.user_management.path} component={UserManagementApp} exact/>
                        <ProtectedRoute path={routes.image_management.path} component={ImageManagementApp} exact/>
                        <ProtectedRoute path={routes.video_management.path} component={VideoManagementApp} exact/>
                        <ProtectedRoute path={routes.audio_management.path} component={AudioManagementApp} exact/>
                        <ProtectedRoute path={routes.document_management.path} component={DocumentManagementApp} exact/>
                        <ProtectedRoute path={routes.banner_management.path} component={BannerManagementApp} exact/>
                        <ProtectedRoute path={routes.article_management.path} component={ArticleManagementApp} exact/>
                        <ProtectedRoute path={routes.promotion_management.path} component={PromotionManagementApp} exact/>
                        <ProtectedRoute path={routes.combo_management.path} component={ComboManagementApp} exact />
                        <ProtectedRoute path={routes.course_management.path} component={CourseManagementApp} exact/>
                        <ProtectedRoute path={routes.chapter_management.path} component={ChapterManagementApp} exact/>
                        <ProtectedRoute path={routes.lesson_management.path} component={LessonManagementApp} exact/>
                        <ProtectedRoute path={routes.quiz_management.path} component={QuizManagementApp} exact/>
                        <ProtectedRoute path={routes.enrollment_management.path} component={EnrollmentManagementApp} exact/>
                        <RegularRoute path="/forbidden-error" component={ForbiddenApp} exact/>
                        <RegularRoute path="/unexpected-error" component={UnexpectedApp} exact/>
                        <RegularRoute component={NotFoundApp}/>
                    </Switch>
                </Layout>
            </BrowserRouter>
        </ContextsWrapper>
    </div>;
}
